import { render, staticRenderFns } from "./InventarioMuniciones.vue?vue&type=template&id=86fa1080&scoped=true"
import script from "./InventarioMuniciones.vue?vue&type=script&lang=js"
export * from "./InventarioMuniciones.vue?vue&type=script&lang=js"
import style0 from "./InventarioMuniciones.vue?vue&type=style&index=0&id=86fa1080&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86fa1080",
  null
  
)

export default component.exports